import React from 'react';
import PropTypes from 'prop-types'
import { useForm, FormProvider } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Input, Switch } from "../Shared/Form";
import { WizardButtons } from "../Wizard";
import { actions, useStore } from "../store";
import { NextButton, ResetButton } from "../Shared/Buttons";
import { contactsFormSchema } from "../schema";

const ContactsStep = ({ stepName }) => {
  const [isPrivateType, setPrivateType] = useStore(state => [state.isPrivateType, state.setPrivateType ])
  const [contactsFormValue, setContactsFormValue, changeContactsFormValue ] =
    useStore(state => [state.contactsFormValue, state.setContactsFormValue, state.changeContactsFormValue])
  const removeSuccessSteps = useStore(state => state.removeSuccessSteps)

  const formMethods = useForm({
    mode: 'onBlur',
    shouldFocusError: false,
    resolver: yupResolver(contactsFormSchema),
    defaultValues: contactsFormValue,
  });

  const handleChange = (fieldName, value) => {
    changeContactsFormValue(fieldName, value)
    removeSuccessSteps(stepName)
  }

  const onSubmit = (data) => {
    setContactsFormValue(data);
    actions.handleWizardNextStep()
  }

  return (
    <FormProvider {...formMethods}>
      <form onSubmit={formMethods.handleSubmit(onSubmit)}>
        <div className="card shadow-lg">
          <div className="card-header">
            <h3 className="card-title">
              Your contact details that will be shown in the Privacy Policy.
            </h3>
          </div>
          <div className="card-body">
            <div className='row'>
              <div className="col-12">
                <div className="mb-3 float-end">
                  <Switch
                    checked={isPrivateType}
                    labelOff='Company'
                    labelOn='Private'
                    onChange={(value) => setPrivateType(value) }
                  />
                </div>
              </div>

                <div className="col-12">
                  <div className="mb-3">
                    <Input
                      labelText='Website'
                      name='website'
                      type='text'
                      handleChange={handleChange}
                      isRequired
                      placeholder='https://www.example.com'
                    />
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12">
                  <div className="mb-3">
                    <Input
                      labelText={ isPrivateType ? 'Your name' : 'Company name' }
                      name='company'
                      type='text'
                      handleChange={handleChange}
                      isRequired
                    />
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12">
                  <div className="mb-3">
                    <Input
                      labelText={ isPrivateType ? 'Your full address' : 'Company full address' }
                      name='address'
                      type='text'
                      handleChange={handleChange}
                      isRequired
                    />
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12">
                  <div className="mb-3">
                    <Input
                      labelText={ isPrivateType ? 'Your email address' : 'Company email address' }
                      name='email'
                      type='email'
                      handleChange={handleChange}
                      isRequired
                    />
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12">
                  <div className="mb-3">
                    <Input
                      labelText={isPrivateType ? 'Your phone number' : 'Company phone number'}
                      name='phone'
                      type='text'
                      handleChange={handleChange}
                    />
                  </div>
                </div>

            </div>
          </div>
          <div className='card-footer'>
            <WizardButtons>
              <ResetButton onClick={() => actions.handleWizardReset()} />
              <NextButton type='submit' />
            </WizardButtons>
          </div>
        </div>
      </form>
    </FormProvider>
  );
}

ContactsStep.propTypes = {
  stepName: PropTypes.string.isRequired,
}

export default ContactsStep;
